import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: JSON.parse(localStorage.getItem("orderedItems")) || [],
};

const orderedItemSlice = createSlice({
  name: "orderedItem",
  initialState,
  reducers: {
    setOrderedItems: (state, action) => {
      state.items = action.payload;
      localStorage.setItem("orderedItems", JSON.stringify(state.items));
    },
    addOrderedItem: (state, action) => {
      state.items.push(action.payload);
      localStorage.setItem("orderedItems", JSON.stringify(state.items));
    },
    updateOrderedItem: (state, action) => {
      const { index, updatedItem } = action.payload;
      if (index >= 0 && index < state.items.length) {
        state.items[index] = { ...updatedItem }; // ensure immutability
        localStorage.setItem("orderedItems", JSON.stringify(state.items));
      }
    },

    removeOrderedItem: (state, action) => {
      const index = action.payload;
      if (index >= 0 && index < state.items.length) {
        state.items = state.items.filter((_, i) => i !== index);
        localStorage.setItem("orderedItems", JSON.stringify(state.items));
      }
    },

    clearOrderedItems: (state) => {
      state.items = [];
      localStorage.removeItem("orderedItems");
    },
  },
});

export const {
  setOrderedItems,
  addOrderedItem,
  updateOrderedItem,
  removeOrderedItem,
  clearOrderedItems,
} = orderedItemSlice.actions;

export default orderedItemSlice.reducer;
